document.addEventListener("DOMContentLoaded", function () {
    // Smooth image load fade-in for product media
    function smoothLoadProductImages(container) {
      const el = container || document;
      const imgs = el.querySelectorAll ? el.querySelectorAll('.product-single__media-slider .swiper-slide img') : [];
      imgs.forEach(function (img) {
        if (img.classList.contains('product-single__media-img--loaded')) return;
        if (img.complete) {
          img.classList.add('product-single__media-img--loaded');
        } else {
          img.addEventListener('load', function () {
            img.classList.add('product-single__media-img--loaded');
          });
        }
      });
    }
    smoothLoadProductImages();

    // Product Single Accordion functionality
    const accordionBtns = document.querySelectorAll("[product-single-accordion-btn], .product-single-accordion-btn");
    if (accordionBtns.length) {
        accordionBtns.forEach(function (btn) {
            btn.addEventListener("click", function () {
                const isExpanded = btn.getAttribute("aria-expanded") === "true";
                const content = btn.nextElementSibling;
                if (!content) return;
                
                btn.setAttribute("aria-expanded", !isExpanded);
                content.setAttribute("aria-expanded", !isExpanded);
                
                // Add transition if not already present
                if (!content.style.transition) {
                    content.style.transition = "height 0.25s ease, opacity 0.25s ease, visibility 0.25s ease";
                }
                
                if (isExpanded) {
                    // Collapse
                    content.style.height = content.scrollHeight + "px";
                    content.offsetHeight; // Force reflow
                    content.style.height = "0";
                    content.style.opacity = "0";
                    content.style.overflow = "hidden";
                    
                    // Hide visibility after transition completes
                    setTimeout(function() {
                        if (btn.getAttribute("aria-expanded") === "false") {
                            content.style.visibility = "hidden";
                        }
                    }, 250);
                } else {
                    // Expand
                    content.style.visibility = "visible";
                    content.style.overflow = "hidden";
                    content.style.height = content.scrollHeight + "px";
                    content.style.opacity = "1";
                    
                    // After transition, set height to auto for dynamic content
                    setTimeout(function() {
                        if (btn.getAttribute("aria-expanded") === "true") {
                            content.style.height = "auto";
                            content.style.overflow = "visible";
                        }
                    }, 250);
                }
            });
        });
    }


    // Helper function to get product data
    function getProductData() {
      const productJsonEl = document.querySelector('[id^="ProductJson-"]');
      if (!productJsonEl) return null;
      try {
        return JSON.parse(productJsonEl.textContent);
      } catch (e) {
        console.error("Failed to parse product JSON", e);
        return null;
      }
    }

    // Helper function to find matching variant based on selected options
    function findMatchingVariant(productData, selectedOptions) {
      if (!productData || !productData.variants) return null;
      
      return productData.variants.find(variant => {
        // Check if all selected options match this variant's options
        return selectedOptions.every((selectedValue, index) => {
          const optionKey = `option${index + 1}`;
          return variant[optionKey] === selectedValue;
        });
      });
    }

    // Helper function to get all currently selected options
    function getSelectedOptions() {
      const options = [];
      const nativeSelects = document.querySelectorAll('select.product-single__form-option-select[data-index]');
      
      // Sort by index to ensure correct order
      const sortedSelects = Array.from(nativeSelects).sort((a, b) => {
        const indexA = parseInt(a.getAttribute('data-index').replace('option-', ''), 10);
        const indexB = parseInt(b.getAttribute('data-index').replace('option-', ''), 10);
        return indexA - indexB;
      });
      
      sortedSelects.forEach(select => {
        options.push(select.value);
      });
      
      return options;
    }

    // Helper function to update variant ID input and URL (URL deferred to avoid redirect/flicker)
    function updateSelectedVariant() {
      const productData = getProductData();
      if (!productData) return null;
      
      const selectedOptions = getSelectedOptions();
      const matchingVariant = findMatchingVariant(productData, selectedOptions);
      
      if (matchingVariant) {
        const variantIdInput = document.querySelector("[product-single-form-variant-id]");
        if (variantIdInput) {
          variantIdInput.value = matchingVariant.id;
        }
        
        // Defer URL update to avoid redirect/flicker during variant transition
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', matchingVariant.id);
            window.history.replaceState({}, '', url.toString());
          });
        });
        
        return matchingVariant;
      }
      
      return null;
    }

    const customDropdowns = document.querySelectorAll(".custom-dropdown");

    // === VARIANT PRODUCTS DROPDOWN (Products as Variants) ===
    const variantProductsDropdown = document.querySelector("[variant-products-dropdown]");
    if (variantProductsDropdown) {
      initVariantProductsDropdown(variantProductsDropdown);
    }

    function initVariantProductsDropdown(dropdown) {
      const selected = dropdown.querySelector(".custom-dropdown__selected");
      const options = dropdown.querySelectorAll(".custom-dropdown__option");
      
      // Get variant products JSON data
      const variantProductsJsonEl = document.querySelector('[variant-products-json]');
      let variantProductsData = [];
      if (variantProductsJsonEl) {
        try {
          variantProductsData = JSON.parse(variantProductsJsonEl.textContent);
        } catch (e) {
          console.error("Failed to parse variant products JSON", e);
        }
      }

      options.forEach(option => {
        option.addEventListener("click", (e) => {
          e.stopPropagation();

          // Each colour is its own product — navigate to that product's page.
          // The server then renders the correct images/price/stock on load,
          // so we don't do a fragile in-place swap.
          const productUrl = option.getAttribute("data-product-url");
          if (productUrl) {
            window.location.href = productUrl;
          }
        });
      });

      // On page load, mark the option matching the current product as selected
      // (we're already on the correct product page — no in-place update needed).
      const currentHandle = window.location.pathname.split('/products/')[1];

      if (currentHandle) {
        options.forEach(opt => {
          opt.classList.toggle('selected', opt.getAttribute('data-product-handle') === currentHandle);
        });
      }

      dropdown.addEventListener("click", (e) => {
        e.stopPropagation();
        customDropdowns.forEach(d => {
          if (d !== dropdown) d.classList.remove("open");
        });
        dropdown.classList.toggle("open");
      });
    }

    // Refresh product recommendations when variant product changes (e.g. from dropdown)
    function refreshProductRecommendations(newProductId) {
      const wrap = document.querySelector('[store-carousel-wrap][data-url*="product_id"]');
      if (!wrap || !wrap.dataset.url) return;

      const url = new URL(wrap.dataset.url, window.location.origin);
      url.searchParams.set('product_id', newProductId);

      fetch(url.toString())
        .then(function (res) { return res.text(); })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newWrap = doc.querySelector('[store-carousel-wrap]');
          if (!newWrap || !newWrap.innerHTML.trim()) return;

          // Update slides in each swiper-wrapper; preserve existing Swiper instances to avoid layout issues
          const existingSliders = wrap.querySelectorAll('[store-carousel-slider]');
          const newSliders = newWrap.querySelectorAll('[store-carousel-slider]');
          if (existingSliders.length !== newSliders.length) {
            wrap.innerHTML = newWrap.innerHTML;
            wrap.dataset.url = url.toString();
            return;
          }
          existingSliders.forEach(function (existingSlider, i) {
            const newWrapper = newSliders[i].querySelector('.swiper-wrapper');
            const existingWrapper = existingSlider.querySelector('.swiper-wrapper');
            if (newWrapper && existingWrapper) {
              existingWrapper.innerHTML = newWrapper.innerHTML;
              if (existingSlider.swiper) {
                existingSlider.swiper.update();
              }
            }
          });
          wrap.dataset.url = url.toString();
          // Update heading if present
          const newHeading = newWrap.querySelector('.m-store-carousel__heading');
          const existingHeading = wrap.querySelector('.m-store-carousel__heading');
          if (newHeading && existingHeading) existingHeading.textContent = newHeading.textContent;
        })
        .catch(function (err) { console.warn('Failed to refresh recommendations:', err); });
    }
    
    // Update PDP content dynamically when selecting a product variant
    function updatePdpWithVariantProduct(productData) {
      console.log('productData',productData)
      
      const newUrl = productData.url;
      const mediaWrap = document.querySelector('.product-single__media-wrap');
      // Only engage the fade-out switch animation when we will actually rebuild
      // the slider (a real variant switch with a live Swiper). At initial page
      // load there is no Swiper yet and the server already rendered the correct
      // media — adding the class here would leave the media stuck at opacity:0,
      // because it is only removed inside the rebuild block below.
      const earlySwiperEl = document.querySelector('.product-single__media-slider');
      const willRebuildMedia = !!(earlySwiperEl && earlySwiperEl.swiper && productData.images && productData.images.length);
      if (mediaWrap && willRebuildMedia) {
        mediaWrap.classList.add('product-single__media-wrap--variant-switching');
      }

      // Update breadcrumb
      const breadcrumbProductLink = document.querySelector('.breadcrumbs__item .breadcrumbs__link[aria-current="page"]');
      if (breadcrumbProductLink) {
        breadcrumbProductLink.textContent = productData.title;
        breadcrumbProductLink.href = productData.url;
      }
      
      // Update page title
      const pageTitle = document.querySelector('.product-single__details-title');
      if (pageTitle) {
        pageTitle.textContent = productData.title;
      }
      document.title = productData.title + ' – ' + (window.shopName || 'French Beauty Co.');

      //Updating the excerpt 
      const excerpt = document.querySelector('.variant-details-excerpt');
      if (excerpt) {
        excerpt.textContent = productData.short_description;
      }

      // Update price
      const priceContainer = document.querySelector("[product-single-form-price] span");
      if (priceContainer && productData.price) {
        const priceInDollars = (productData.price / 100).toFixed(2);
        priceContainer.textContent = `$${priceInDollars}`;
      }
      
      // Update compare at price
      const compareContainer = document.querySelector("[product-single-form-price] del");
      if (compareContainer) {
        if (productData.compare_at_price && productData.compare_at_price > productData.price) {
          const compareInDollars = (productData.compare_at_price / 100).toFixed(2);
          compareContainer.textContent = `$${compareInDollars}`;
          compareContainer.style.display = '';
        } else {
          compareContainer.style.display = 'none';
        }
      }
      
      // Update Afterpay amounts
      const afterpays = document.querySelectorAll('.product-single__afterpays-amount span');
      if (afterpays && productData.price) {
        afterpays.forEach(afterpay => {
          const afterpayAmount = productData.price / 4 / 100;
          const formatted = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(afterpayAmount);
          afterpay.innerText = formatted;
        });
      }
      
      // Update hidden variant ID input
      const variantInput = document.querySelector('[product-single-form-variant-id]');
      if (variantInput) {
        variantInput.value = productData.variant_id;
      }

      //Updating Description
      const descAccordion = document.querySelector('.product-single__accordion:not([data-index])');
      const descContentEl = descAccordion?.querySelector('.product-single__accordion-content-inner--content');
      if (descContentEl) {
        descContentEl.innerHTML = productData.variant_description || '';
      }


      //Updating accordians
      for (let i = 1; i <= 3; i++) {
        const title = productData[`accordion_title_${i}`];
        const description = productData[`accordion_description_${i}`];
        const accordion = document.querySelector(`.product-single__accordion[data-index="${i}"]`);
        if (!accordion) continue;

        const btn = accordion.querySelector('.product-single__accordion-btn');
        const contentEl = accordion.querySelector('.product-single__accordion-content-inner');

        if (title && description) {
          // Update button text node only (leave the chevron icon intact)
          btn.childNodes[0].textContent = title + ' ';
          if (contentEl) contentEl.innerHTML = description;
          accordion.style.display = '';
        } else {
          accordion.style.display = 'none';
        }
      }

      
      // Update featured image in slider
      // Reset swiper to first slide
      const swiperEl = document.querySelector('.product-single__media-slider');
      // Use the live Swiper instance if one is attached. Do NOT create one here:
      // this runs during init (line ~222) before the Swiper library/instance exists,
      // and the slide-handling blocks below are already guarded by `if (activeSwiperInstance)`.
      const activeSwiperInstance = swiperEl?.swiper || null;

      if (activeSwiperInstance) {
        try {
          activeSwiperInstance.slideToLoop(0, 0);
          activeSwiperInstance.update();
        } catch (e) {
          console.warn('Swiper reset failed:', e);
        }
      }

      // Rebuild all slides based on new product's images.
      // Only when a Swiper instance exists — at initial load the server already
      // rendered the correct slides, and rebuilding without a swiper to manage
      // them would leave the slider broken.
      if (activeSwiperInstance && productData.images && productData.images.length) {
        const swiperWrapper = swiperEl?.querySelector('.swiper-wrapper');
        
        if (swiperWrapper) {
          // Lock slider height to prevent collapse while new images load
          const mediaSlider = document.querySelector('.product-single__media-slider');
          const lockedSliderHeight = mediaSlider ? mediaSlider.offsetHeight : 0;
          if (mediaSlider && lockedSliderHeight) {
            mediaSlider.style.minHeight = lockedSliderHeight + 'px';
          }

          // Remove all existing slides (including duplicates)
          swiperWrapper.innerHTML = '';
          
          // Rebuild slides from productData.images with smooth load fade-in
          productData.images.forEach((imageUrl, index) => {
            const baseSrc = typeof imageUrl === 'string'
              ? (imageUrl.includes('?') ? imageUrl.split('?')[0] : imageUrl)
              : imageUrl;

            const slide = document.createElement('div');
            slide.classList.add('swiper-slide');
            const img = document.createElement('img');
            img.src = baseSrc + '?width=1000';
            img.srcset = `${baseSrc}?width=352 352w, ${baseSrc}?width=832 832w, ${baseSrc}?width=1000 1000w`;
            img.alt = productData.title;
            img.loading = index === 0 ? 'eager' : 'lazy';
            img.addEventListener('load', function onImgLoad() {
              img.classList.add('product-single__media-img--loaded');
            });
            if (img.complete) img.classList.add('product-single__media-img--loaded');
            slide.appendChild(img);
            swiperWrapper.appendChild(slide);
          });

          // Reinitialise swiper loop with new slides
          const isMobile = window.innerWidth <= 900;
          function performSwiperReset() {
            try {
              activeSwiperInstance.loopDestroy();
              activeSwiperInstance.loopCreate();
              activeSwiperInstance.update();
              activeSwiperInstance.slideToLoop(0, 0);
              
              const progressEl = document.querySelector("[product-single-media-progressbar]");
              if (progressEl) {
                const fill = progressEl.querySelector('.swiper-pagination-progressbar-fill');
                if (fill) {
                  fill.style.transition = 'none';
                  fill.style.transform = 'scaleX(0)'; // reset to start
                  requestAnimationFrame(function () {
                    fill.style.transition = ''; // restore transition
                  });
                }
              }
              
              refreshCounter(0); // Pass forceStartIndex = 0 since the index resets
            } catch (e) {
              console.warn('Swiper reinit failed:', e);
            }
          }

          if (isMobile) {
            setTimeout(performSwiperReset, 500);
          } else {
            performSwiperReset();
          }

          // Release switching state after transition/load
          setTimeout(function() {
            if (mediaWrap) mediaWrap.classList.remove('product-single__media-wrap--variant-switching');
          }, isMobile ? 1200 : 700);

          // Release height lock when first image has loaded (or after fallback delay)
          function releaseSliderHeight() {
            if (mediaSlider) mediaSlider.style.minHeight = '';
          }
          const firstImg = swiperWrapper.querySelector('.swiper-slide img');
          if (firstImg) {
            if (firstImg.complete) {
              releaseSliderHeight();
            } else {
              firstImg.addEventListener('load', releaseSliderHeight);
            }
          }
          setTimeout(releaseSliderHeight, 800);
        }
      }
      
      // Update quantity max and reset quantity to 1
      const qtyInput = document.querySelector('[product-single-form-quantity-value]');
      const decBtn = document.querySelector('[product-single-form-quantity-decrement]');
      const incBtn = document.querySelector('[product-single-form-quantity-increment]');
      
      if (qtyInput) {
        let maxQty = productData.inventory_policy === "continue" ? 9999 : (productData.inventory_quantity || 0);
        qtyInput.value = 1;
        qtyInput.setAttribute("data-max", maxQty);
        
        if (decBtn) decBtn.disabled = true;
        if (incBtn) incBtn.disabled = maxQty <= 1;
      }
      
      // Update Add to Cart button
      const atcBtn = document.querySelector('[product-single-form-submit]');
      if (atcBtn) {
        if (!productData.available) {
          atcBtn.innerHTML = atcBtn.dataset.soldOutText || "SOLD OUT";
          atcBtn.disabled = true;
        } else {
          atcBtn.innerHTML = atcBtn.dataset.addText || "Add to Bag";
          atcBtn.disabled = false;
        }
      }
      
      // Update wishlist button data
      const wishlistBtn = document.querySelector('.wc_wl_bis_btn, .th_wl_col_btn');
      if (wishlistBtn) {
        wishlistBtn.setAttribute('data-product_id', productData.id);
        wishlistBtn.setAttribute('data-variant_id', productData.variant_id);
      }

      // Update Cartx ATC wrapper so the button reflects the selected variant product
      const productForm = document.querySelector('form[product-form], form[action="/cart/add"]');
      const atcWrapper = productForm?.querySelector('.cartx-product-button-wrap') || document.querySelector('.cartx-product-button-wrap[data-product-id]');
      if (atcWrapper) {
        const maxInventory = productData.inventory_policy === 'continue' ? 9999 : (productData.inventory_quantity || 0);
        atcWrapper.setAttribute('data-variant-id', productData.variant_id);
        atcWrapper.setAttribute('data-price', productData.price);
        atcWrapper.setAttribute('data-inventory', maxInventory);
        atcWrapper.setAttribute('data-available', productData.available ? 'true' : 'false');
      }
      if (typeof updateInventoryStates === 'function') {
        updateInventoryStates(productData.variant_id);
        setTimeout(() => updateInventoryStates(productData.variant_id), 50);
      }

      // Refresh product recommendations for the new product
      refreshProductRecommendations(productData.id);

      // Defer URL update to avoid redirect/flicker during variant product transition
      setTimeout(function () {
        window.history.replaceState({}, '', newUrl);
      }, 900);

      setTimeout(function () {
          const checkWidgetCount = document.querySelectorAll(`.th_prd_wl_btn`);
          checkWidgetCount.forEach((quickProduct) => {
            quickProduct.innerHTML = '';
            quickProduct.setAttribute('data-product_id',productData.id);
            quickProduct.setAttribute('data-variant_id',productData.variant_id);
          })
      }, 500);

    }
    
    // === QUANTITY CONTROLS WITH MAX LIMIT ===
    initPdpQuantityControls();
    
    function initPdpQuantityControls() {
      const qtyInput = document.querySelector('[product-single-form-quantity-value]');
      const decBtn = document.querySelector('[product-single-form-quantity-decrement]');
      const incBtn = document.querySelector('[product-single-form-quantity-increment]');
      
      if (!qtyInput || !decBtn || !incBtn) return;
      
      // Remove existing event listeners by cloning
      const newIncBtn = incBtn.cloneNode(true);
      const newDecBtn = decBtn.cloneNode(true);
      incBtn.parentNode.replaceChild(newIncBtn, incBtn);
      decBtn.parentNode.replaceChild(newDecBtn, decBtn);
      
      // Initial button state
      updateQtyButtonStates(qtyInput, newDecBtn, newIncBtn);
      
      newIncBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const max = parseInt(qtyInput.getAttribute("data-max"), 10) || 9999;
        let qty = parseInt(qtyInput.value, 10) || 1;
        if (qty < max) {
          qty++;
          qtyInput.value = qty;
          updateQtyButtonStates(qtyInput, newDecBtn, newIncBtn);
        }
      });
      
      newDecBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        let qty = parseInt(qtyInput.value, 10) || 1;
        if (qty > 1) {
          qty--;
          qtyInput.value = qty;
          updateQtyButtonStates(qtyInput, newDecBtn, newIncBtn);
        }
      });
    }
    
    function updateQtyButtonStates(input, decBtn, incBtn) {
      const max = parseInt(input.getAttribute("data-max"), 10) || 9999;
      const qty = parseInt(input.value, 10) || 1;
      decBtn.disabled = qty <= 1;
      incBtn.disabled = qty >= max;
    }

    // === ORIGINAL VARIANT DROPDOWNS ===
    customDropdowns.forEach(customDropdown => {
      // Skip variant products dropdown (already handled above)
      if (customDropdown.hasAttribute('variant-products-dropdown')) return;
      
      const selected = customDropdown.querySelector(".custom-dropdown__selected");
      const options = customDropdown.querySelectorAll(".custom-dropdown__option");
      const customIndex = customDropdown.getAttribute("data-index");
      const nativeIndex = customIndex ? customIndex.replace("custom-", "") : null;
      const nativeSelect = nativeIndex ? document.querySelector(`select[data-index="${nativeIndex}"]`) : null;

      options.forEach(option => {
        option.addEventListener("click", (e) => {
          e.stopPropagation();
          const value = option.getAttribute("data-value");
          
          // ✅ Check if this is a color option (has color swatch)
          const colorSwatch = option.querySelector('.color-swatch');
          
          if (colorSwatch) {
            // Clone the color swatch and update selected display
            selected.innerHTML = '';
            const clonedSwatch = colorSwatch.cloneNode(true);
            selected.appendChild(clonedSwatch);
            
            // Add the text value
            const textNode = document.createTextNode(' ' + value);
            selected.appendChild(textNode);
          } else {
            // No color swatch, just update text
            selected.textContent = value;
          }
          
          options.forEach(opt => opt.classList.remove("selected"));
          option.classList.add("selected");
          customDropdown.classList.remove("open");

          if (nativeSelect) {
            nativeSelect.value = value;
            nativeSelect.dispatchEvent(new Event("input", { bubbles: true }));
            nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));
          } else {
            updateSelectedVariant();
            updateVariantImage();
          }
        });
      });

      if (nativeSelect) {
        nativeSelect.addEventListener("change", () => {
          const newValue = nativeSelect.value;
          
          // ✅ Find the matching option
          const matchingOption = Array.from(options).find(opt => 
            opt.getAttribute("data-value") === newValue
          );
          
          if (matchingOption) {
            const colorSwatch = matchingOption.querySelector('.color-swatch');
            
            if (colorSwatch) {
              // Clone the color swatch and update selected display
              selected.innerHTML = '';
              const clonedSwatch = colorSwatch.cloneNode(true);
              selected.appendChild(clonedSwatch);
              
              // Add the text value
              const textNode = document.createTextNode(' ' + newValue);
              selected.appendChild(textNode);
            } else {
              // No color swatch, just update text
              selected.textContent = newValue;
            }
          }
          
          options.forEach(opt => {
            opt.classList.toggle("selected", opt.getAttribute("data-value") === newValue);
          });

          // ✅ Update variant ID based on selected options, then update image
          updateSelectedVariant();
          updateVariantImage();
        });
      }



      customDropdown.addEventListener("click", (e) => {
        e.stopPropagation();
        customDropdowns.forEach(d => {
          if (d !== customDropdown) d.classList.remove("open");
        });
        customDropdown.classList.toggle("open");
      });
    });

    document.addEventListener("click", () => {
      customDropdowns.forEach(dropdown => dropdown.classList.remove("open"));
    });

    const counterEl = document.querySelector("[product-single-media-counter]");
    const currentEl = document.querySelector("[product-single-media-count]");
    const totalTextEl = counterEl?.childNodes[2];
    const progressEl = document.querySelector("[product-single-media-progressbar]");
    const wrapper = document.querySelector(".product-single__media-slider");
    const swiperInstance = getSwiperInstance();

    function refreshCounter(forceStartIndex) {
      if (!swiperInstance || !counterEl) return;
      const allSlides = wrapper.querySelectorAll(".swiper-slide");
      const visibleRealSlides = Array.from(allSlides).filter(slide =>
        !slide.classList.contains("is--hidden") &&
        !slide.classList.contains("swiper-slide-duplicate")
      );

      const currentRealIndex = typeof forceStartIndex === 'number' ? forceStartIndex : swiperInstance.realIndex;
      let currentVisibleIndex = 1;
      for (let i = 0; i < visibleRealSlides.length; i++) {
        // Fallback to data attribute if swiperSlideIndex property is missing on rebuilt elements
        const slideIdx = visibleRealSlides[i].swiperSlideIndex != null 
          ? visibleRealSlides[i].swiperSlideIndex 
          : parseInt(visibleRealSlides[i].getAttribute('data-swiper-slide-index'), 10);
          
        if (slideIdx === currentRealIndex || isNaN(slideIdx) && i === currentRealIndex) {
          currentVisibleIndex = i + 1;
          break;
        }
      }

      if (currentEl) {
        currentEl.textContent = currentVisibleIndex;
      }

      if (totalTextEl) {
        totalTextEl.textContent = ` / ${visibleRealSlides.length} Images`;
      }

      if (progressEl) {
        const pct = (currentVisibleIndex / visibleRealSlides.length) * 100;
        progressEl.style.setProperty("--progress", `${pct}%`);
        
        // Sync Swiper's built-in progressbar fill
        const fill = progressEl.querySelector('.swiper-pagination-progressbar-fill');
        if (fill) {
          fill.style.transform = `scaleX(${currentVisibleIndex / visibleRealSlides.length})`;
        }
      }
    }

    function getVariantSlideRange(productData, variant) {
      if (!variant?.featured_media?.position) return null;

      const totalMedia = productData.media.length;
      const allPositions = productData.variants
        .filter(v => v.featured_media?.position)
        .map(v => v.featured_media.position)
        .sort((a, b) => a - b);

      const startPos = variant.featured_media.position;
      const idx = allPositions.indexOf(startPos);
      const nextPos = allPositions[idx + 1];
      const startIndex = startPos - 1;
      const endIndex = nextPos ? nextPos - 2 : totalMedia - 1;

      return { startIndex, endIndex };
    }

    function filterSlidesByIndexRange(startIndex, endIndex) {
      const slides = wrapper.querySelectorAll('.swiper-slide');
      slides.forEach(slide => {
        const idx = slide.swiperSlideIndex;
        const hide = idx < startIndex || idx > endIndex;
        slide.classList.toggle('is--hidden', hide);
      });

      swiperInstance.update();
      refreshCounter();
    }

    async function updateVariantImage() {
      const variantIdInput = document.querySelector("[product-single-form-variant-id]");
      const variantId = variantIdInput?.value;
      if (!variantId) return;

      const productJsonEl = document.querySelector('[id^="ProductJson-"]');
      if (!productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent);
      } catch (e) {
        console.error("Failed to parse product JSON", e);
        return;
      }

      const variant = productData.variants.find(v => v.id == variantId);
      if (!variant) return;

      const priceContainer = document.querySelector("[product-single-form-price] span");
      const variantTitle = document.querySelector('.product-single__details-title');
      const variantDescriptions = document.querySelector(`#VariantDescriptions [data-variant-id="${variantId}"]`);
      const variantDescriptionContainer = document.querySelector('.product-single__accordion.description .product-single__accordion-content .product-single__accordion-content-inner');
      const variantAccordionJsonEl = document.getElementById('VariantAccordionJSON');
      const afterpays = document.querySelectorAll('.product-single__afterpays-amount span');
      const badges = document.querySelectorAll('.product-single__badge');
      const variantBadges = document.querySelectorAll(`.product-single__badge.badge-${variantId}`);
      const bundle = document.querySelector(`.bundle-${variantId}`);
      const bundles = document.querySelectorAll('.bundles');
      let accordionData = JSON.parse(variantAccordionJsonEl.textContent);
      const variantAccordion = accordionData[variantId] || {};
      const productMetafields = productData?.metafields?.fbc || {};
      const variantDetailsExcerpt = document.querySelector('.variant-details-excerpt');
      const variantDetails = document.querySelector(`#VariantDetails [data-variant-id="${variantId}"]`);

      const detailsWrapper = document.querySelector('.product-single__details');
      const lockedHeight = detailsWrapper ? detailsWrapper.offsetHeight : 0;
      if (detailsWrapper && lockedHeight) {
        detailsWrapper.style.minHeight = lockedHeight + 'px';
      }

      // Lock media slider/wrap height BEFORE any DOM changes to prevent flickering (especially on mobile)
      const mediaSlider = document.querySelector('.product-single__media-slider');
      const mediaWrap = document.querySelector('.product-single__media-wrap');
      let lockedSliderHeight = mediaSlider ? mediaSlider.offsetHeight : 0;
      if (lockedSliderHeight === 0 && typeof window !== 'undefined') {
        lockedSliderHeight = Math.max(280, window.innerHeight * 0.35);
      }
      if (mediaSlider && lockedSliderHeight) {
        mediaSlider.style.minHeight = lockedSliderHeight + 'px';
      }
      if (mediaWrap && lockedSliderHeight) {
        mediaWrap.style.minHeight = lockedSliderHeight + 'px';
      }
      if (mediaWrap) {
        mediaWrap.classList.add('product-single__media-wrap--variant-switching');
      }

      requestAnimationFrame(function applyVariantUpdates() {
        if (variantDetailsExcerpt && variantDetails) {
      if (variantDetails.innerHTML.trim() !== '') {
        // Update with variant-specific details (truncated)
        const fullText = variantDetails.innerHTML.replace(/<[^>]*>/g, ''); // Strip HTML
        const truncated = fullText.split(' ').slice(0, 20).join(' ') + (fullText.split(' ').length > 20 ? '...' : '');
        variantDetailsExcerpt.innerHTML = truncated;
      } else {
        // Fallback to product description
        variantDetailsExcerpt.innerHTML = productData.description;
      }
    }

      if (priceContainer) {
        const priceInDollars = (variant.price / 100).toFixed(2);
        priceContainer.textContent = `$${priceInDollars}`;
      }

      if (afterpays) {
        afterpays.forEach(afterpay => {
          const afterpayAmount = variant.price / 4 / 100; // assuming variant.price is in cents
      
          const formatted = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD', // or 'AUD', 'INR', etc.
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(afterpayAmount);
      
          afterpay.innerText = formatted;
        });
      }
      
      if (bundles) {
        bundles.forEach(bundle => {
          bundle.style.display = 'none';
        });
      }

      if (bundle) {
        bundle.style.display = 'block';
      }

      if (badges) {
        badges.forEach(badge => {
          badge.style.display = 'none';
        });
      }

      if(variantBadges) {
        variantBadges.forEach(badge => {
          badge.style.display = 'block';
        })
      }

      if (variantDescriptionContainer && variantDescriptions) {
        if (variantDescriptions != null) {
          variantDescriptionContainer.innerHTML = variantDescriptions.innerHTML;
        } else {
          variantDescriptionContainer.innerHTML = productData.description;
        }
        
      }

      for (let i = 1; i <= 3; i++) {
        const title = variantAccordion[`title_${i}`] || productMetafields[`accordion_title_${i}`];
        const description = variantAccordion[`description_${i}`] || productMetafields[`accordion_description_${i}`];
      
        const accordion = document.querySelector(`.product-single__accordion[data-index="${i}"]`);
        const titleEl = accordion?.querySelector('.accordion-title-text');
        const contentEl = accordion?.querySelector('.product-single__accordion-content-inner');
      
        if (title && description) {
          if (titleEl) titleEl.innerText = title;
          if (contentEl) contentEl.innerHTML = description;
          if (accordion) accordion.style.display = '';
        } else if (accordion) {
          accordion.style.display = 'none'; // Hide if nothing exists
        }
      }

      if (variant.featured_media) {
        const range = getVariantSlideRange(productData, variant);
        if (range) {
          filterSlidesByIndexRange(range.startIndex, range.endIndex);

          const featuredRealIndex = variant.featured_media.position - 1;
          const slideSpeed = 500;
          if (swiperInstance) {
            const isMobile = window.innerWidth <= 900;
            
            if (isMobile) {
              // Mobile-specific fix
              setTimeout(function () {
                try {
                  // Rebuild loop so touch swiping doesn't catch hidden clones
                  swiperInstance.loopDestroy();
                  swiperInstance.loopCreate();
                  swiperInstance.update();
                  
                  // Slide to the first image of the variant
                  swiperInstance.slideToLoop(range.startIndex, 0);
                  
                  // Force reset the built-in pagination fill
                  const progressEl = document.querySelector("[product-single-media-progressbar]");
                  
                  if (progressEl) {
                    const fill = progressEl.querySelector('.swiper-pagination-progressbar-fill');
                    if (fill) {
                      fill.style.transition = 'none';
                      fill.style.transform = 'scaleX(0)'; // reset to start
                      requestAnimationFrame(function () {
                        fill.style.transition = ''; // restore transition
                      });
                    }
                  }
                  
                  // Run existing counter logic
                  if (typeof refreshCounter === 'function') {
                    refreshCounter();
                  }
                } catch (e) {
                  console.error('[DEBUG Swiper Mobile] Mobile swiper reset failed:', e);
                }
              }, 500); // 500ms delay as requested for mobile
            } else {
              // Original desktop logic
              requestAnimationFrame(function () {
                swiperInstance.slideToLoop(featuredRealIndex, slideSpeed);
              });
            }
          }
        }
      }

      // Remove variant-switching class after transition; keep minHeight to prevent jump on release (mobile)
      const isMobileSw = typeof window !== 'undefined' && window.innerWidth <= 900;
      const releaseDelay = isMobileSw ? 1200 : 700;
      setTimeout(function releaseVariantSwitch() {
        const mWrap = document.querySelector('.product-single__media-wrap');
        if (mWrap) mWrap.classList.remove('product-single__media-wrap--variant-switching');
      }, releaseDelay);

      if (variantTitle) {
        variantTitle.innerText = variant.name;
      }

        requestAnimationFrame(function clearMinHeight() {
          if (detailsWrapper) detailsWrapper.style.minHeight = '';
        });
      });

      // Update quantity selector max value based on variant inventory
      const qtyWrapper = document.querySelector("[product-single-form-quantity]");
      if (qtyWrapper) {
        const qtyInput = qtyWrapper.querySelector("[product-single-form-quantity-value]");
        const incBtn = qtyWrapper.querySelector("[product-single-form-quantity-increment]");
        const decBtn = qtyWrapper.querySelector("[product-single-form-quantity-decrement]");
        
        if (qtyInput) {
          // Get inventory quantity from variant
          const inventoryQuantity = variant.inventory_quantity;
          const inventoryPolicy = variant.inventory_policy;
          
          // If inventory_policy is 'continue', allow unlimited purchases
          let maxQty = 9999;
          if (inventoryPolicy !== 'continue' && typeof inventoryQuantity === 'number') {
            maxQty = inventoryQuantity > 0 ? inventoryQuantity : 0;
          }
          
          // Fetch cart to calculate remaining available quantity
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const cartItem = cart.items.find(item => item.id === variant.id);
              const quantityInCart = cartItem ? cartItem.quantity : 0;
              
              // Calculate remaining quantity that can be added
              let remainingQty = inventoryPolicy === 'continue' ? 9999 : Math.max(0, maxQty - quantityInCart);
              
              qtyInput.dataset.max = remainingQty;
              // Reset quantity to 1 or max available if current exceeds remaining
              let currentQty = parseInt(qtyInput.value, 10) || 1;
              if (currentQty > remainingQty) {
                qtyInput.value = remainingQty > 0 ? Math.min(currentQty, remainingQty) : 1;
                currentQty = parseInt(qtyInput.value, 10);
              }
              
              // If no remaining quantity, set to 1 but buttons will be disabled
              if (remainingQty === 0) {
                qtyInput.value = 1;
                currentQty = 1;
              }
              
              // Update button states
              if (incBtn) {
                incBtn.disabled = currentQty >= remainingQty || remainingQty === 0;
              }
              if (decBtn) {
                decBtn.disabled = currentQty <= 1;
              }
            })
            .catch(err => {
              console.warn("Failed to fetch cart for quantity update:", err);
              // Fallback: use variant inventory directly
              qtyInput.dataset.max = maxQty;
              let currentQty = parseInt(qtyInput.value, 10) || 1;
              if (currentQty > maxQty) {
                qtyInput.value = maxQty > 0 ? maxQty : 1;
                currentQty = parseInt(qtyInput.value, 10);
              }
              if (incBtn) incBtn.disabled = currentQty >= maxQty;
              if (decBtn) decBtn.disabled = currentQty <= 1;
            });
        }

        // Update ATC button wrapper and state based on variant availability (async)
        // Find the closest form context to locate the correct ATC button
        const productForm = document.querySelector('form[product-form], form[action="/cart/add"]');
        const atcWrapper = productForm?.querySelector(".cartx-product-button-wrap") || document.querySelector(".cartx-product-button-wrap[data-product-id]");
        const atcBtn = atcWrapper?.querySelector(".cartx-add-to-cart");
        
        // Check if variant is truly available (has stock and is marked as available)
        const hasStock = variant.inventory_policy === 'continue' || (typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0);
        const isVariantAvailable = variant.available && hasStock;
        
        // Update wrapper attributes for the new variant
        if (atcWrapper) {
          const maxQtyForVariant = variant.inventory_policy === 'continue' ? 9999 : (variant.inventory_quantity || 0);
          atcWrapper.setAttribute('data-variant-id', variant.id);
          atcWrapper.setAttribute('data-price', variant.price);
          atcWrapper.setAttribute('data-inventory', maxQtyForVariant);
          atcWrapper.setAttribute('data-available', isVariantAvailable ? 'true' : 'false');
          
          // IMPORTANT: Always reset classes first before applying new state
          atcWrapper.classList.remove('cartx-button-soldout', 'cartx-sold-out', 'cartx-max-stock');
          if (atcBtn) {
            atcBtn.classList.remove('cartx-sold-out', 'cartx-max-stock');
            atcBtn.removeAttribute('disabled');
          }
          
          // Update sold out state classes
          if (!isVariantAvailable) {
            atcWrapper.classList.add('cartx-button-soldout');
            if (atcBtn) {
              atcBtn.classList.add('cartx-sold-out');
              atcBtn.disabled = true;
              // Update button text
              const soldOutText = atcWrapper.getAttribute('data-sold-out-text') || 'Sold out';
              const buttonTextSpan = atcBtn.querySelector('span');
              if (buttonTextSpan) {
                buttonTextSpan.textContent = soldOutText;
              }
            }
          } else {
            // Available - already reset above, now set correct text
            if (atcBtn) {
              // Update button text
              const addText = atcWrapper.getAttribute('data-add-text') || 'Add to bag';
              const buttonTextSpan = atcBtn.querySelector('span');
              if (buttonTextSpan) {
                buttonTextSpan.textContent = addText;
              }
            }
          }
        
        }
        
        if (atcBtn) {
          // Fetch current cart to check inventory
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              let quantityInCart = 0;
              const cartItem = cart.items.find(item => item.id === variant.id);
              quantityInCart = cartItem ? cartItem.quantity : 0;
              
              // Update wrapper's in-cart attribute
              if (atcWrapper) {
                atcWrapper.setAttribute('data-in-cart', quantityInCart);
              }
              
              const maxAvailable = variant.inventory_policy === 'continue' ? 9999 : (variant.inventory_quantity || 0);
              const isMaxStockInCart = quantityInCart >= maxAvailable && variant.inventory_policy !== 'continue' && maxAvailable > 0;
              const isSoldOut = !isVariantAvailable;
              
              // Remove all stock-related classes and attributes first
              atcBtn.classList.remove('disabled', 'out-of-stock', 'cartx-max-stock', 'cartx-sold-out');
              atcBtn.removeAttribute('disabled');
              
              // Get or create span element for button text
              let span = atcBtn.querySelector('span');
              if (!span) {
                span = document.createElement('span');
                atcBtn.prepend(span);
              }
              
              // Update button state based on availability
              if (isSoldOut) {
                atcBtn.classList.add('cartx-sold-out');
                atcBtn.setAttribute('disabled', 'disabled');
                span.textContent = 'Sold Out';
              } else if (isMaxStockInCart) {
                atcBtn.classList.add('cartx-max-stock');
                atcBtn.setAttribute('disabled', 'disabled');
                span.textContent = 'MAX PRODUCT LIMIT';
              } else {
                span.textContent = 'Add to Bag';
              }
              
            })
            .catch(err => {
              console.warn("Failed to fetch cart for variant update:", err);
              // Fallback: just check availability
              atcBtn.classList.remove('disabled', 'cartx-max-stock', 'cartx-sold-out');
              
              let span = atcBtn.querySelector('span');
              if (span) {
                if (!isVariantAvailable) {
                  atcBtn.classList.add('cartx-sold-out');
                  atcBtn.setAttribute('disabled', 'disabled');
                  span.textContent = 'Sold Out';
                } else {
                  atcBtn.removeAttribute('disabled');
                  span.textContent = 'Add to Bag';
                }
              }
            });
        }
      }

      // Update inventory states for ATC buttons after variant change
      if (typeof updateInventoryStates === 'function') {
        // Call immediately after variant data is updated
        updateInventoryStates(variant.id);
        
        // Also call after a small delay to ensure all DOM updates are complete
        setTimeout(() => {
          updateInventoryStates(variant.id);
        }, 50);
      } else {
        console.warn('updateInventoryStates function not found');
      }
    }

    if (swiperInstance) {
      swiperInstance.on("slideChange", refreshCounter);
    }

    function getSwiperInstance() {
      const swiperEl = document.querySelector('.product-single__media-slider');
      if (!swiperEl) return null;

      if (swiperEl.swiper) {
        return swiperEl.swiper;
      }

      return new Swiper(swiperEl, {
        loop: true,
        slidesPerView: 1,
        speed: 500,
        navigation: {
          nextEl: '.product-single__media-arrow--next',
          prevEl: '.product-single__media-arrow--previous'
        }
      });
    }
  });